<template>
  <a :href="to" class="btn preset-filled-primary-500 transition-all flex flex-row items-center py-5" :class="size">
    <slot />
  </a>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'PrimaryButtonLink',
  props: {
    to: String,
    size: {
      type: String as PropType<'btn-md' | 'btn-lg' | 'btn-base' | 'btn-sm'>,
      default: 'btn-lg',
    },
  },
});
</script>
